
import WpImage from '~/components/ui/img.vue';
import SliderUi from '@/components/ui/slider.vue';
import Link from '@/components/ui/link.vue';

export default {
  name: 'Slider',

  components: {
    WpImage,
    SliderUi,
    Link,
  },

  filters: {
    sliced: (v) => {
      const string = v.replace(/<[^]p>*>/g, '').replace(/<p>*>/g, '');
      return v && string.length > 0 ? string : null;
    },
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    noTags() {
      const div = document.createElement('div');
      if (this.item && this.item.item_text) {
        div.innerHTML(this.item.item_text);
      }
      return this.item?.item_text ? div.innerHTML : '';
    },
  },
};
